import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import {
  getSavedCardsResponse,
  setDefaultCardRequest,
  setDefaultCardResponse,
} from '../../slices/customer';
import axios from '../axiosConfig';
import { setDefaultSelectedCard, setSelectedCreditCard } from '../../slices/trip';

function* setDefaultCardWorker({
  payload: { card, customerId, withAddressOnly, doShowPaymentCheckboxes, paymentMethodIndex },
}) {
  try {
    const url = '/users/setDefaultCard';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        card: card.id,
        cardId: card.cardId,
        withAddressOnlyCards: withAddressOnly,
        customerId,
        doShowPaymentCheckboxes,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);

    if (data && data.length) {
      yield put(
        setDefaultSelectedCard({
          customerId,
          cards: data,
        }),
      );
      yield put(getSavedCardsResponse({ cards: data, customerId }));
    }
    yield put(
      setDefaultCardResponse({
        error: !data || !data.length ? 'Could not set default card!' : undefined,
        cards: data,
        customerId,
        card,
      }),
    );
  } catch (error) {
    yield put(setDefaultCardResponse({ error: 'Could not set default card!', customerId, card }));
    console.error(error);
  }
}

function* setDefaultCardWatcher() {
  yield takeLatest(setDefaultCardRequest.toString(), setDefaultCardWorker);
}

export default setDefaultCardWatcher;
